/**
 * API Service for BtnCellRenderer
 */

import { makeCygnusApiCall } from "../../../../../api/api";

/**
 * Downloads the EL based on filename and container.
 * @param
 * @returns data array.
 */
export const downloadEngagementLetter = async (fileName: any, containerName: any): Promise<any> => {  
  const url = `/download/blob/?FileName=${fileName}&ContainerName=${containerName}`;

  const response = await makeCygnusApiCall({
    type: "GET",
    url,
    show_message: false,
    customized_success_message: "Downloaded EL successfully.",
    customized_failure_message:
      "Unable to Download EL, please try again.",
    customized_error_message:
      "Error occurred while Downloading EL. Please contact support.",
    forMDM: true,
    isblob: true
  });

  if (response instanceof Blob) {
    return response;
  }
  return null;
};